define(function () {
  return /<([\w:-]+)/;
});